export function getAllStageData() {
    return [
        {
            buttonName:"Case Data",
            buttonID: 1
        },
        {
            buttonName: "Card Brand Data",
            buttonID: 2
        }
    ]
}
